"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorClass = void 0;
function ValidatorClass(validator) {
    var _a;
    return _a = class {
            constructor(value) {
                const result = validator.strip(value);
                const descs = Object.getOwnPropertyDescriptors(result);
                Object.defineProperties(this, descs);
            }
        },
        _a.validator = validator,
        _a;
}
exports.ValidatorClass = ValidatorClass;
//# sourceMappingURL=ValidatorClass.js.map